export const aciInfo = {
    iconName: 'info',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M14 16.001h-.667a1.333 1.333 0 01-1.334-1.333v-3.333a.666.666 0 00-.666-.667h-.667',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M11.667 7.999a.333.333 0 010-.667M11.666 7.999a.333.333 0 000-.667',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                },
            },
            {
                attr: {
                    d: 'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z',
                    stroke: 'currentColor',
                    'stroke-width': '1.215',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
